import { useStatsOverview } from './useStatsOverview'
import type { StatsOverview } from './types'

export type { InvoiceStats, InvoiceStatEntry } from './types'

export function useInvoiceStats() {
  const q = useStatsOverview()
  return { ...q, data: q.data?.invoices as StatsOverview['invoices'] | undefined }
}
